import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ProductModal.module.sass";
import Icon from "../../components/Icon";
import Product from "./product";

const ProductModal = ({ visible, onClose, nfts = false, ...rest }) => {
	useEffect(() => {
		if (visible) {
			const target = document.querySelector("#modal-product");
			disableBodyScroll(target);
		} else {
			clearAllBodyScrollLocks();
		}
	}, [visible]);

	return createPortal(
		visible && (
			<div id="modal-product" className={styles.modal}>
				<div className={styles.control}></div>
				<div className={styles.outer}>
					<button className={styles.close} onClick={onClose}>
						<Icon name="close" size="20" />
					</button>
					<Product nfts={nfts} {...rest} />
				</div>
			</div>
		),
		document.body
	);
};

export default ProductModal;
